import { render, staticRenderFns } from "./Disinfect.vue?vue&type=template&id=b324b702&scoped=true&"
import script from "./Disinfect.vue?vue&type=script&lang=ts&"
export * from "./Disinfect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b324b702",
  null
  
)

export default component.exports